import Axios from "axios";
import { SETTINGS } from "../../properties/ApiProps";

export const FormBuilderRepository = {
  save: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}customForm`,
      method: "POST",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  findById: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}customForm/id`,
      method: "GET",
      params: { id: id },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  findAll: () => {
    return Axios({
      url: `${SETTINGS.API_URL}customForm`,
      method: "GET",
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  delete: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}customForm`,
      method: "DELETE",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
};
